export default __webpack_public_path__ + "static/media/save-to-list.61d5f9dc.svg";